export default __webpack_public_path__ + "static/media/9.81410956.jpg";